<template>
  <div class="ks-ky">
    <div class="ks-ky-top">
      <header class="ks-ky-header com-header-wrap">
        <div class="com-header">
          <span class="header-logo-new"></span>
        </div>
      </header>
      <div class="ks-ky-top-text">
        <div class="ks-ky-top-text-inner">
          <h2 class="ks-ky-h2">{{ $t('kwaiCut.slogan') }}</h2>
          <h3 class="ks-ky-h3">{{ $t('kwaiCut.subtitle') }}</h3>
          <div class="ks-ky-h4">{{ $t('kwaiCut.desc') }}</div>
          <div class="ks-ky-qr-container">
            <div id="ks-ky-qr" class="ks-ky-qr">
              {{ $t('kwaiCut.scanDownload') }}
            </div>
            <div class="os-icon">
              <a
                id="ks-ky-qr-os-ios"
                href="https://apps.apple.com/app/id6450880581"
                class="ks-ky-qr-os-ios"
              ></a>
              <a
                id="ks-ky-qr-os-android"
                href="https://play.google.com/store/apps/details?id=com.kwai.editor"
                class="ks-ky-qr-os-android"
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ul class="ks-ky-main">
      <li class="ks-ky-row ks-ky-row1">
        <div class="ks-ky-column-wrapper">
          <div class="ks-ky-column ks-ky-intro">
            <h2 class="ks-ky-intro-h2">{{ $t('kwaiCut.featTitle1') }}</h2>
            <h3 class="ks-ky-intro-h3">{{ $t('kwaiCut.featDesc1') }}</h3>
          </div>
          <div class="ks-ky-column ks-ky-img"></div>
        </div>
      </li>
      <li class="ks-ky-row ks-ky-row2">
        <div class="ks-ky-column-wrapper">
          <div class="ks-ky-column ks-ky-img"></div>
          <div class="ks-ky-column ks-ky-intro ks-ky-right">
            <h2 class="ks-ky-intro-h2">{{ $t('kwaiCut.featTitle2') }}</h2>
            <h3 class="ks-ky-intro-h3">{{ $t('kwaiCut.featDesc2') }}</h3>
          </div>
        </div>
      </li>
      <li class="ks-ky-row ks-ky-row3">
        <div class="ks-ky-column-wrapper">
          <div class="ks-ky-column ks-ky-intro">
            <h2 class="ks-ky-intro-h2">{{ $t('kwaiCut.featTitle3') }}</h2>
            <h3 class="ks-ky-intro-h3">{{ $t('kwaiCut.featDesc3') }}</h3>
          </div>
          <div class="ks-ky-column ks-ky-img"></div>
        </div>
      </li>
      <li class="ks-ky-row ks-ky-row4">
        <div class="ks-ky-column-wrapper">
          <div class="ks-ky-column ks-ky-img"></div>
          <div class="ks-ky-column ks-ky-intro ks-ky-right">
            <h2 class="ks-ky-intro-h2">{{ $t('kwaiCut.featTitle4') }}</h2>
            <h3 class="ks-ky-intro-h3">{{ $t('kwaiCut.featDesc4') }}</h3>
          </div>
        </div>
      </li>
      <li class="ks-ky-row ks-ky-row5">
        <div class="ks-ky-column-wrapper">
          <div class="ks-ky-column ks-ky-intro">
            <h2 class="ks-ky-intro-h2">{{ $t('kwaiCut.featTitle5') }}</h2>
            <h3 class="ks-ky-intro-h3">{{ $t('kwaiCut.featDesc5') }}</h3>
          </div>
          <div class="ks-ky-column ks-ky-img"></div>
        </div>
      </li>
    </ul>
    <div
      style="color: #aaa; font-size: 20px; text-align: center; padding: 20px 0;"
    >
      Copyright @ 2023-{{ new Date().getFullYear() }} KWAI TECHNOLOGY LIMITED.
      All rights Reserved.
    </div>
  </div>
</template>

<script>
export default {
  head: {
    title: 'KwaiCut',
    meta: [
      {
        name: 'viewport',
        content:
          'width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=0',
      },
    ],
  },
}
</script>

<style>
.ks-ky .ks-ky-top,
.ks-ky .ks-ky-top-text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.com-header-wrap {
  min-width: 1200px;
  height: 70px;
  font-size: 14px;
  background: #222;
}
.com-header-wrap .com-header {
  height: 100%;
  margin: 0 60px;
  position: relative;
}
.com-header-wrap .com-header .header-logo-new {
  position: absolute;
  display: block;
  cursor: pointer;
  left: 0;
  height: 32px;
  top: 20px;
  z-index: 1;
  width: 200px;
  background: url(https://ali2.a.kwimgs.com/udata/pkg/kmovie/kwaicut_icon.png)
    no-repeat 0 0 !important;
  background-size: contain !important;
}
.ks-ky .ks-ky-top-text {
  display: flex;
  width: 960px;
  margin: 0 auto;
  color: #fff;
  -webkit-box-flex: 1;
  -ms-flex: 1 1;
  flex: 1 1;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.ks-ky .ks-ky-top-text .ks-ky-h2 {
  font-size: 48px;
  font-weight: 700;
}
.ks-ky .ks-ky-top-text .ks-ky-h3 {
  font-size: 34px;
  font-weight: 700;
  padding-top: 30px;
}
.ks-ky .ks-ky-top-text .ks-ky-h4 {
  font-size: 14px;
  padding-top: 20px;
  padding-bottom: 40px;
}
.ks-ky .ks-ky-top {
  height: 800px;
  background: top/auto 100% no-repeat
    url(//s2-11673.kwimgs.com/kos/nlav11673/static/img/pages/kuaiying/index/img/ks_ky_bg-68e4ae0b.png);
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.ks-ky .ks-ky-top-text .ks-ky-qr-container {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: start;
  -ms-flex-pack: start;
  justify-content: flex-start;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
}
.ks-ky .ks-ky-top-text .ks-ky-qr-container .ks-ky-qr {
  background: hsla(0, 0%, 100%, 0) 0 0 / contain no-repeat
    url(//s2-11673.kwimgs.com/udata/pkg/frontend-explore/ks_ky_qr_1x.png);
  width: 160px;
  height: 22px;
  padding-top: 170px;
  color: hsla(0, 0%, 100%, 0.7);
  font-size: 14px;
  text-align: center;
}
.ks-ky .ks-ky-top-text .ks-ky-qr-container .os-icon {
  width: 220px;
  height: 160px;
  margin-left: 40px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}
.ks-ky .ks-ky-top-text .ks-ky-qr-container .os-icon .ks-ky-qr-os-ios {
  background: url(//s2-11673.kwimgs.com/udata/pkg/frontend-explore/ks_ky_os_ios_1x.png);
  width: 220px;
  height: 60px;
  margin-bottom: 28px;
  background-size: contain;
  text-decoration: none;
}
.ks-ky .ks-ky-top-text .ks-ky-qr-container .os-icon .ks-ky-qr-os-android {
  background: url(//s2-11673.kwimgs.com/udata/pkg/frontend-explore/ks_ky_os_android_1x.png);
  width: 220px;
  height: 60px;
  background-size: contain;
}
.ks-ky-main {
  list-style: none;
}
.ks-ky .ks-ky-main .ks-ky-row {
  background: #fff;
}
.ks-ky .ks-ky-main .ks-ky-row:nth-child(2n) {
  background: #fcfcfc;
}
.ks-ky .ks-ky-main .ks-ky-column-wrapper {
  width: 960px;
  margin: 0 auto;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}

.ks-ky .ks-ky-main .ks-ky-intro {
  background-repeat: no-repeat;
  background-position: 0;
  background-position: 0 0;
  background-size: 144px;
  padding-top: 144px;
}
.ks-ky .ks-ky-main .ks-ky-row1 .ks-ky-intro {
  background-image: url(//s2-11673.kwimgs.com/kos/nlav11673/static/img/pages/kuaiying/index/img/ks_ky_desc_icon1-462a97d4.png);
}
.ks-ky .ks-ky-main .ks-ky-row2 .ks-ky-intro {
  background-image: url(//s2-11673.kwimgs.com/kos/nlav11673/static/img/pages/kuaiying/index/img/ks_ky_desc_icon2-2b55d779.png);
}
.ks-ky .ks-ky-main .ks-ky-row3 .ks-ky-intro {
  background-image: url(//s2-11673.kwimgs.com/kos/nlav11673/static/img/pages/kuaiying/index/img/ks_ky_desc_icon3-a5cd4343.png);
}
.ks-ky .ks-ky-main .ks-ky-row4 .ks-ky-intro {
  background-image: url(//s2-11673.kwimgs.com/kos/nlav11673/static/img/pages/kuaiying/index/img/ks_ky_desc_icon4-fa6ae5d2.png);
}
.ks-ky .ks-ky-main .ks-ky-row5 .ks-ky-intro {
  background-image: url(//s2-11673.kwimgs.com/kos/nlav11673/static/img/pages/kuaiying/index/img/ks_ky_desc_icon5-ec3bbac1.png);
}
.ks-ky .ks-ky-main .ks-ky-column {
  width: 500px;
}
.ks-ky .ks-ky-main .ks-ky-intro-h2 {
  padding-top: 40px;
  color: #303030;
  font-size: 36px;
  font-weight: 700;
}
.ks-ky .ks-ky-main .ks-ky-intro-h3 {
  padding-top: 20px;
  color: #5e5e5e;
  font-size: 24px;
}
.ks-ky .ks-ky-main .ks-ky-img {
  height: 780px;
  background-repeat: no-repeat;
}
.ks-ky .ks-ky-main .ks-ky-row1 .ks-ky-img {
  background-image: url(//s2-11673.kwimgs.com/kos/nlav11673/static/img/pages/kuaiying/index/img/ks_ky_desc_img1-b13b7e43.png);
}
.ks-ky .ks-ky-main .ks-ky-row2 .ks-ky-img {
  background-image: url(//s2-11673.kwimgs.com/kos/nlav11673/static/img/pages/kuaiying/index/img/ks_ky_desc_img2-05c15068.png);
}
.ks-ky .ks-ky-main .ks-ky-row3 .ks-ky-img {
  background-image: url(//s2-11673.kwimgs.com/kos/nlav11673/static/img/pages/kuaiying/index/img/ks_ky_desc_img3-aae3edd1.png);
}
.ks-ky .ks-ky-main .ks-ky-row4 .ks-ky-img {
  background-image: url(//s2-11673.kwimgs.com/kos/nlav11673/static/img/pages/kuaiying/index/img/ks_ky_desc_img4-afdd196f.png);
}
.ks-ky .ks-ky-main .ks-ky-row5 .ks-ky-img {
  background-image: url(//s2-11673.kwimgs.com/kos/nlav11673/static/img/pages/kuaiying/index/img/ks_ky_desc_img5-16515000.png);
}
</style>
